import script from "./GraduatesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GraduatesTable.vue?vue&type=script&setup=true&lang=js"

import "./GraduatesTable.vue?vue&type=style&index=0&id=854112b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854112b6"]])

export default __exports__